import { render, staticRenderFns } from "./pos_sync.vue?vue&type=template&id=18755c32&scoped=true&"
import script from "./pos_sync.vue?vue&type=script&lang=js&"
export * from "./pos_sync.vue?vue&type=script&lang=js&"
import style0 from "./pos_sync.vue?vue&type=style&index=0&id=18755c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18755c32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18755c32')) {
      api.createRecord('18755c32', component.options)
    } else {
      api.reload('18755c32', component.options)
    }
    module.hot.accept("./pos_sync.vue?vue&type=template&id=18755c32&scoped=true&", function () {
      api.rerender('18755c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/pos/pos_sync/pos_sync.vue"
export default component.exports